import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PhotoCollectionDto } from '../../../../models/trofaco/photoCollectionDto';
import { ArrayHelper } from '../../../../models/helpers/array-helper';
import { PhotoDto } from '../../../../models/trofaco/photoDto';
import { PhotoCollectionService } from '../../../core/services/photo-collection.service';
import { Observable } from 'rxjs';
import { ConfirmDeleteModalComponent } from '../../../core/components/delete-modal/confirm-delete-modal-component';

@Component({
    selector: 'app-documentation',
    templateUrl: './documentation.component.html'
})
export class DocumentationComponent implements OnInit {
    get collections(): PhotoCollectionDto[] {
        return this._collections;
    }

    get newDocument(): PhotoCollectionDto {
        return this._newDocument;
    }

    @Input()
    set collections(value: PhotoCollectionDto[]) {
        if (value) {
            for (let photoCollectionDto of value) {
                photoCollectionDto.date = new Date(photoCollectionDto.date);
            }
        }    
        this._collections = value;
        this.sortCollectionByDate();
    }

    @Output()
    collectionsChange = new EventEmitter<PhotoCollectionDto[]>();

    private _collections: PhotoCollectionDto[];
    private _newDocument: PhotoCollectionDto = {id: '', photos: new Array<PhotoDto>()};

    @Input()
    siteId: string;

    @Input()
    titles$: Observable<string[]>;

    @ViewChild(ConfirmDeleteModalComponent, { static: true }) confirmDelete: ConfirmDeleteModalComponent;

    constructor(
        private collectionService: PhotoCollectionService,
    ) {
    }

    ngOnInit() {
    }

    async create() {
        this._newDocument.plantingSiteId = this.siteId;
        this._newDocument.id = await this.saveDocument(this._newDocument);
        this._newDocument = {id: '', photos: new Array<PhotoDto>()};
    }

    async saveDocument(document: PhotoCollectionDto ) {
        let id = await this.collectionService.saveDocument(this.siteId, document);
        this._collections = [document, ...this._collections.filter(value => value.id != document.id)];
        this.sortCollectionByDate();
        this.collectionsChange.emit(this._collections);
        return id;
    }

    async displayConfirmDialogue(collection: PhotoCollectionDto) {
        let result = await this.confirmDelete.showAwait('');
        if (result) {
            let deletedId = await this.collectionService.deletDocument(collection.id);
            this._collections = this._collections.filter(c => c.id != deletedId);
            this.collectionsChange.emit(this._collections);
        }
    }

    sortCollectionByDate() {
        this._collections = ArrayHelper.sortBy( this._collections, false, coll => coll.date);
    }
}
